import { MouseEventHandler } from 'react';
import { GraphQLTaggedNode, useMutation, UseMutationConfig } from 'react-relay';

import ConfirmButton, { ConfirmButtonProps } from '../ConfirmButton';

type Props<
  TMutation extends {
    readonly response: {};
    readonly variables: { readonly input?: {} | null };
    readonly rawResponse?: {} | undefined;
  },
> = {
  mutation: GraphQLTaggedNode;
  input: TMutation['variables']['input'];
  config?: Omit<UseMutationConfig<TMutation>, 'variables'>;
} & ConfirmButtonProps;

const MutationConfirmButton = <
  TMutation extends {
    readonly response: {};
    readonly variables: { readonly input?: {} | null };
    readonly rawResponse?: {} | undefined;
  },
>({
  mutation,
  input,
  config,
  onClick,
  disabled,
  ...props
}: Props<TMutation>) => {
  const [mutate, isLoading] = useMutation(mutation);

  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    onClick?.(e);
    mutate({ ...(config ? config : {}), variables: { input: input } });
  };

  return <ConfirmButton onClick={handleClick} disabled={isLoading || disabled} {...props} />;
};

export default MutationConfirmButton;
export type { Props as MutationConfirmButtonProps };
